export const engineStateProKey = 'engineStatePro';
export const brakesStateProKey = 'brakesStatePro';
export const interiorStateProKey = 'interiorStatePro';
export const suspensionStateProKey = 'suspensionStatePro';
export const transmissionStateProKey = 'transmissionStatePro';
export const clearVehicleProKey = 'clearVehiclePro';
